import React, { useContext } from "react"
import { TransitionGroup, CSSTransition } from "react-transition-group"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"
import Subscribe from "./Subscribe"

import ArchiveItem from "./ArchiveItem"
import MaintenanceMode from "./MaintenanceMode"
import { LangContext } from "./LangContext"
import NewsLetterForm from "./NewsLetterForm"
// import { ReactComponent as FacebookShareIcon } from "../icons/facebook-share-icon.svg"
// import { ReactComponent as LinkedinShareIcon } from "../icons/linkedin-share-icon.svg"
// import { ReactComponent as TwitterShareIcon } from "../icons/twitter-share-icon.svg"
// import { ReactComponent as InstagramShareIcon } from "../icons/instagram-share-icon.svg"
import Hero from "./Hero"
import Analytics from "./Analytics"
import GridWrap from "./GridWrap"
import Highlight from "./Highlight"
import { useHomePage } from "../hooks/use-home-page"

const Home = ({ match }) => {
  const [lang] = useContext(LangContext)
  const {
    doc,
    contentCards,
    highlightDoc,
    heroDoc,
    newsletterActive,
    handleNewsLetter,
    // socialLinks,
    analytics,
    highlight,
    subscribeDoc,
  } = useHomePage(match)

  const renderContentCards = () =>
    contentCards.slice(0, 6).map((card) => {
      return <ArchiveItem key={card.uid} item={card} />
    })

  // const renderNewsLetter = () => (
  //   <div className="masonry-grid__item item--newsletter">
  //     <h2>
  //       {lang === "fi"
  //         ? "Tilaa uutiskirjeemme ja tiedät missä suomalainen muotoilu menee"
  //         : "Subscribe to our newsletter and you will get the latest updates about Finnish design"}
  //     </h2>
  //     <div className="button-container">
  //       <button
  //         aria-label={lang === "fi" ? "Tilaa uutiskirjeemme" : "Subscribe to our newsletter"}
  //         className="button"
  //         onClick={handleNewsLetter}
  //       >
  //         {lang === "fi" ? "Tilaa" : "Subscribe"}
  //       </button>
  //     </div>
  //   </div>
  // )

  // const renderSocialMedia = () =>
  //   socialLinks && (
  //     <div className="masonry-grid__item item--social-links">
  //       <h2>{lang === "fi" ? "Seuraa meitä" : "Follow us on social media"}</h2>
  //       <div className="follow">
  //         <div className="follow__top-row">
  //           {socialLinks.facebook_link && socialLinks.facebook_link[0].text !== "" && (
  //             <a
  //               href={socialLinks.facebook_link[0].text}
  //               rel="noreferrer"
  //               target="_blank"
  //               aria-label={
  //                 lang === "fi" ? "Finnish Design Infon Facebook-sivu" : "Facebook page of Finnish Design Info"
  //               }
  //             >
  //               <FacebookShareIcon />
  //             </a>
  //           )}
  //           {socialLinks.instagram_link && socialLinks.instagram_link[0].text !== "" && (
  //             <a
  //               href={socialLinks.instagram_link[0].text}
  //               rel="noreferrer"
  //               target="_blank"
  //               aria-label={
  //                 lang === "fi" ? "Finnish Design Infon Instagram-sivu" : "Instagram page of Finnish Design Info"
  //               }
  //             >
  //               <InstagramShareIcon />
  //             </a>
  //           )}
  //           {socialLinks.linkedin_link && socialLinks.linkedin_link[0].text !== "" && (
  //             <a
  //               href={socialLinks.linkedin_link[0].text}
  //               rel="noreferrer"
  //               target="_blank"
  //               aria-label={
  //                 lang === "fi" ? "Finnish Design Infon LinkedIn-sivu" : "LinkedIn page of Finnish Design Info"
  //               }
  //             >
  //               <LinkedinShareIcon />
  //             </a>
  //           )}
  //           {socialLinks.twitter_link && socialLinks.twitter_link[0].text !== "" && (
  //             <a
  //               href={socialLinks.twitter_link[0].text}
  //               rel="noreferrer"
  //               target="_blank"
  //               aria-label={lang === "fi" ? "Finnish Design Infon Twitter-sivu" : "Twitter page of Finnish Design Info"}
  //             >
  //               <TwitterShareIcon />
  //             </a>
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   )
  const renderHero = () => {
    let newHeroData = {
      title: "",
      buttonText: "",
      text: "",
      to: "",
      animation: false,
      highlightFirstSentence: false,
    }
    if (heroDoc) {
      const { title, buttonlabel, text, animationshown } = heroDoc
      // const to = !buttonlink?.slug || buttonlink.slug === "-" ? buttonlink.type : buttonlink.slug
      // hardcoding to avoid errors 404
      const to = "about"

      newHeroData = {
        title: title ? title.map((t) => t.text).join(" ") : "",
        buttonText: buttonlabel ? buttonlabel[0].text : "",
        text: text ? text.map((t) => t.text).join(" ") : "",
        to: lang === "fi" ? to : `${to}?lang=en-US`,
        animation: animationshown,
        highlightFirstSentence: heroDoc.highlightfirstsentence,
      }
    }
    return (
      <Hero
        to={newHeroData.to}
        title={newHeroData.title}
        text={newHeroData.text}
        buttonText={newHeroData.buttonText}
        highlightFirstSentence={newHeroData.highlightFirstSentence}
        animation={newHeroData.animation}
        loading={!heroDoc}
      />
    )
  }

  const renderAnalytics = () => {
    if (analytics) {
      return <Analytics data={analytics} />
    }
  }

  const renderHighlight = () => {
    if (highlight && highlightDoc) {
      const image = {
        alt: highlightDoc.featured_image.alt ?? "Highlight Image",
        url: highlightDoc.featured_image.url ?? "",
        preview: highlightDoc.featured_image.preview.url ?? "",
      }
      const data = {
        title: highlight.primary.title1 ? highlight.primary.title1.map((item) => item.text).join(" ") : "",
        text: highlight.primary.text ? highlight.primary.text.map((item) => item.text).join("") : "",
        type: highlight.primary.readmore.type ?? "",
        uid: highlight.primary.readmore.uid ?? "",
        image: image,
      }
      return (
        <Highlight
          bgcolor="#A0C8C8"
          title={data.title}
          text={data.text}
          image={data.image}
          uid={data.uid}
          type={data.type}
        />
      )
    } else return null
  }

  return (
    <>
      <Helmet>
        <title>{doc.title !== "" ? `${doc.title} - Finnish Design Info` : ""}</title>
        {doc.meta_description !== "" && <meta name="description" content={doc.meta_description} />}
      </Helmet>
      {doc.uid && (
        <TransitionGroup>
          <div className="archive">
            <CSSTransition timeout={500} classNames="fade">
              <>
                {renderHero()}
                {renderAnalytics()}
                {renderHighlight()}
                <div className="events_separator" />
                <h2 className="events_title">{lang === "fi" ? "Ajankohtaista" : "Latest news"}</h2>
                {doc.slices.length > 0 && (
                  <div className="container-fluid">
                    <GridWrap>
                      {/* @DEPRICATED */}
                      {/* {renderNewsLetter()} */}
                      {renderContentCards()}
                      {/* {renderSocialMedia()} */}
                    </GridWrap>
                  </div>
                )}
                <Link to={lang === "fi" ? "/stories" : "/stories?lang=en-US"} className="button">
                  {lang === "fi" ? "Lue lisää" : "View all"}
                </Link>
                {subscribeDoc ? (
                  <Subscribe title={subscribeDoc.title[0].text} buttonText={subscribeDoc.button_label[0].text} />
                ) : null}
                <NewsLetterForm newsletterActive={newsletterActive} handleNewsLetter={handleNewsLetter} />
              </>
            </CSSTransition>
          </div>
        </TransitionGroup>
      )}
      {doc.maintenance_mode === "true" && <MaintenanceMode isActive={doc.maintenance_mode} />}
    </>
  )
}

export default Home
